import { Big } from 'big.js';
import { DisplayData, TenantJobLine } from '~/lib/model';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import BreJob from '~/tenants/bre/model/BreJob';
import BreCoversConfig from '~/tenants/bre/performable/print/covers/BreCoversConfig';
import { BreCoversPay, BreCoversRate } from '~/tenants/bre/performable/print/covers/BreCoversData';
import { BreProviderId } from '~/tenants/bre/model/BreProvider';
import { datetime } from '~/lib/datettime';

export default class BreCoversJob extends BreJob<typeof BreCoversConfig> {
  get performable(): typeof BreCoversConfig {
    return BreCoversConfig;
  }

  get configurable(): boolean {
    return true;
  }

  get eligible(): boolean {
    return false;
  }

  get assignee(): string | null {
    return BreProviderId.PRINT_TEAM.toString();
  }

  info(): DisplayData[] {
    const info = super.info();

    info.push({
      name: 'Count',
      value: this.metadata.count,
      provider: true,
    });

    info.push({
      name: 'Need By',
      value: datetime(this.metadata.need_by, this.order.location.timezone).toFormat('LLL dd, yyyy'),
      provider: true,
    });

    return info;
  }

  isDelivery(): boolean {
    return true;
  }

  isPrint(): boolean {
    return true;
  }

  isFreeDelivery(): boolean {
    return true;
  }

  defaultValue(): ZodVersionedMetadata<(typeof BreCoversConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
      count: '100',
      need_by: datetime(this.order.created, this.order.timezone).toSQLDate()
    };
  }

  revenueLines(): TenantJobLine[] {
    const { count } = this.metadata;
    const rate = BreCoversRate[count];
    const lines: TenantJobLine[] = [];

    if (rate) {
      lines.push({
        id: 'covers_print',
        description: `Folders cover (x${count})`,
        amount: new Big(rate),
        taxable: true,
      });
    }

    return lines;
  }

  expenseLines(): TenantJobLine[] {
    const { count } = this.metadata;
    const pay = BreCoversPay[count];
    const lines: TenantJobLine[] = [];

    if (pay) {
      lines.push({
        id: 'covers_print',
        description: `Folders cover (x${count})`,
        amount: new Big(pay),
      });
    }

    return lines;
  }
}
